import { CollectionViewer, DataSource } from "@angular/cdk/collections";
import { Injectable } from '@angular/core';
import { ENETDOWN } from 'constants';
import { size, split } from 'lodash';
import { Observable, BehaviorSubject, of, throwError } from "rxjs";
import { catchError, finalize } from "rxjs/operators";
import { InterventiService } from './interventi.service';

@Injectable({
    providedIn: 'root'
  })
  export class InterventiDataSource implements DataSource<ModelEventiCalamitosi.InterventoDtoElenco> {

    private interventoSubject = new BehaviorSubject<ModelEventiCalamitosi.InterventoDtoElenco[]>([]);
    private loadingSubject = new BehaviorSubject<boolean>(false);
    public loading$ = this.loadingSubject.asObservable();
    private errorSubject = new BehaviorSubject<boolean>(false);
    public errors$ = this.errorSubject.asObservable();
    isLoading: boolean = false;
    errorMessage: string = null;

    private countSubject = new BehaviorSubject<number>(0);
    public counter$ = this.countSubject.asObservable();

    constructor(private interventiService: InterventiService) {
    }

    loadInterventi(ipa: string,
      controlList: ModelEventiCalamitosi.InterventoDtoElenco[],
      operazioneSuTutti: string,
      filter: ModelEventiCalamitosi.InterventoSearchableDto,
      sortDirection: string,
      pageIndex: number,
      pageSize: number) {

      this.loadingSubject.next(true);

      this.interventiService.getList(pageIndex, pageSize, sortDirection, {
        idIntervento: filter.idIntervento,
        codiceIntervento: filter.codiceIntervento,
        dpgr: filter.dpgr,
        stato: filter.stato,
        idEnte: filter.idEnte,
        descrIntervento: filter.descrIntervento,
        idStatoProgetto: filter.idStatoProgetto,
        idStatoEsecuzione: filter.idStatoEsecuzione,
        localita: filter.localita,
        enteAttuatore: filter.enteAttuatore,
        idPriorita: filter.idPriorita,
        importoComplRichiestoDa: filter.importoComplRichiestoDa,
        importoComplRichiestoA: filter.importoComplRichiestoA,
        importoSpeseSostenuteDa: filter.importoSpeseSostenuteDa,
        importoSpeseSostenuteA: filter.importoSpeseSostenuteA,
        dataInizioLavoriDa: filter.dataInizioLavoriDa,
        dataInizioLavoriA: filter.dataInizioLavoriA,
        dataFineLavoriDa: filter.dataFineLavoriDa,
        dataFineLavoriA: filter.dataFineLavoriA,
        ocdpc: filter.ocdpc,
        ricerca:filter.ricerca
      }).pipe(
        catchError(err => {
          this.errorSubject.next(true);
          return throwError(err);
        }),
        catchError(err => {
          return of([]);
        }),
        finalize(() => this.loadingSubject.next(false))
      )
        .subscribe(result => {
          let listaInterventiBE: ModelEventiCalamitosi.InterventoDtoElenco[] = result['content'];
        if (operazioneSuTutti === "S") {
          listaInterventiBE.forEach(interventoBE => {
            interventoBE.aggiunto = true;
          })
          controlList.forEach(interventoFE => {
            listaInterventiBE.forEach(interventoBE => {
              if (interventoBE.idIntervento === interventoFE.idIntervento) {
                if (interventoFE.aggiunto === true) {
                  interventoBE.aggiunto = false;
                }
              }
            })
          })
        } else {
          controlList.forEach(interventoFE => {
            listaInterventiBE.forEach(interventoBE => {
              if (interventoBE.idIntervento === interventoFE.idIntervento) {
                interventoBE.aggiunto = true;
              }
            })
          })
        }
          this.interventoSubject.next(result['content']);
          this.countSubject.next(result['totalElements']);
        }
        );
    }

    connect(collectionViewer: CollectionViewer): Observable<ModelEventiCalamitosi.InterventoDtoElenco[]> {
      return this.interventoSubject.asObservable();
    }

    disconnect(collectionViewer: CollectionViewer): void {
      this.interventoSubject.complete();
      this.loadingSubject.complete();
    }

  }
